import React from 'react'

const Supplier = () => {
  return (
    <div className='mx-auto p-4'>
      Supplier
    </div>
  )
}

export default Supplier
